// Stepper Setup Wizardu - 5 krokow z indykacja postepu.

import React, { FC } from 'react';
import classnames from 'classnames';
import { Check } from 'react-bootstrap-icons';

import styles from 'theme/components/wise/WiseSetupStepper/WiseSetupStepper.module.scss';

export interface ISetupStep {
  id: number;
  label: string;
}

interface IWiseSetupStepperProps {
  steps: ISetupStep[];
  currentStepIndex: number;
  completedSteps: number[];
  onStepClick?: (stepIndex: number) => void;
  className?: string;
}

const WiseSetupStepper: FC<IWiseSetupStepperProps> = ({
  steps,
  currentStepIndex,
  completedSteps,
  onStepClick,
  className
}) => {
  const isCompleted = (stepId: number): boolean => completedSteps.includes(stepId);

  const isClickable = (stepIndex: number, stepId: number): boolean =>
    Boolean(onStepClick) && (isCompleted(stepId) || stepIndex === currentStepIndex);

  return (
    <div className={classnames(styles.componentWrapper, className)} role="navigation">
      {steps.map((step, index) => {
        const completed = isCompleted(step.id);
        const isCurrent = index === currentStepIndex;
        const clickable = isClickable(index, step.id);

        return (
          <React.Fragment key={step.id}>
            <div
              className={classnames(styles.step, {
                [styles.stepCompleted]: completed,
                [styles.stepCurrent]: isCurrent,
                [styles.stepClickable]: clickable
              })}
              onClick={clickable && onStepClick ? () => onStepClick(index) : undefined}
              role={clickable ? 'button' : undefined}
              tabIndex={clickable ? 0 : undefined}>
              <div className={styles.circle}>
                {completed ? <Check size={18} /> : <span>{step.id}</span>}
              </div>
              <div className={styles.label}>{step.label}</div>
            </div>
            {index < steps.length - 1 && (
              <div
                className={classnames(styles.connector, {
                  [styles.connectorActive]: completed
                })}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default WiseSetupStepper;
